import type { GameLayer } from "../engine/Game.js";
import type { GpuContext } from "../engine/GpuContext.js";
import { SceneRenderer, type SceneRendererOptions } from "./SceneRenderer.js";

export interface SceneLayerOptions extends SceneRendererOptions {
  /** Where among the game's layers it draws. 0 by default, under any front-end. */
  order?: number;
}

/**
 * A three.js scene drawn across the whole canvas, as one layer of a `Game` - the world a game is set in,
 * with the windowing UI, if any, laid over it.
 *
 * ```ts
 * const world = new SceneLayer(game.gpu, { scene, camera });
 * game.addLayer(world);
 * ```
 */
export class SceneLayer extends SceneRenderer implements GameLayer {
  readonly order: number;
  /** Skip drawing while false. */
  visible = true;

  constructor(gpu: GpuContext, options: SceneLayerOptions = {}) {
    super(gpu, options);
    this.order = options.order ?? 0;
  }

  draw(): void {
    if (this.visible) this.render(null);
  }
}
